/* ===========================================================================
   MUSEA — PDP web components (vanilla, IIFE, zéro dépendance)
   ---------------------------------------------------------------------------
   <facil-pdp>          : état variante (taille → écrit le [name=id] caché, maj prix + labels)
   <facil-gallery>      : slider scroll-snap (compteur, dots, flèches, nudge)
   <facil-savoir-plus>  : « en savoir plus » → ouvre l'accordéon Description + scroll doux
   Le panier reste géré par <product-form> (product-form.js Dawn) : on n'y touche pas.
   =========================================================================== */
(function () {
  'use strict';

  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------------
     <facil-pdp> — source unique de vérité = le [name=id] caché du form
     --------------------------------------------------------------------- */
  if (!customElements.get('facil-pdp')) {
    customElements.define(
      'facil-pdp',
      class FacilPdp extends HTMLElement {
        connectedCallback() {
          this.idInput = this.querySelector('input[name="id"]');
          this.priceEl = this.querySelector('[data-pdp-price]');
          this.radios = Array.prototype.slice.call(this.querySelectorAll('input[name="facil-size"]'));
          if (!this.radios.length) return; /* produit mono-variante : rien à piloter */
          var self = this;
          this.radios.forEach(function (r) {
            r.addEventListener('change', function () {
              if (r.checked) self.select(r);
            });
          });
        }

        select(radio) {
          if (this.idInput) this.idInput.value = radio.value;
          var money = radio.getAttribute('data-price-money');
          if (money) {
            if (this.priceEl) {
              this.priceEl.innerHTML = '<span class="facil-price"><span class="facil-price__regular">' + money + '</span></span>';
            }
            /* maj du prix dans le bouton ET dans les calques directionnels clonés */
            Array.prototype.slice.call(this.querySelectorAll('[data-pdp-btn-price]')).forEach(function (el) {
              el.textContent = money;
            });
          }
          /* Galerie : on affiche la photo liée a la variante choisie. */
          var mediaId = radio.getAttribute('data-media-id');
          if (mediaId) {
            var gal = document.querySelector('facil-gallery');
            if (gal && typeof gal.goToMedia === 'function') gal.goToMedia(mediaId);
          }

          /* maj de la taille affichée dans « Contenu de la boîte » */
          var sizeTitle = radio.getAttribute('data-title');
          if (sizeTitle) {
            Array.prototype.slice.call(this.querySelectorAll('[data-pdp-size-label]')).forEach(function (el) {
              el.textContent = sizeTitle;
            });
          }
        }
      }
    );
  }

  /* ---------------------------------------------------------------------
     <facil-gallery> — slider natif scroll-snap ; JS = compteur/dots/nudge
     --------------------------------------------------------------------- */
  if (!customElements.get('facil-gallery')) {
    customElements.define(
      'facil-gallery',
      class FacilGallery extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.facil-gallery__track');
          this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-gallery-slide]'));
          if (!this.track || this.slides.length <= 1) return;

          this.current = this.querySelector('[data-gallery-current]');
          this.dots = Array.prototype.slice.call(this.querySelectorAll('.facil-gallery__dot'));
          this.prevBtn = this.querySelector('[data-gallery-prev]');
          this.nextBtn = this.querySelector('[data-gallery-next]');
          this.index = 0;
          this._ticking = false;

          var self = this;
          if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self.go(self.index - 1); });
          if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self.go(self.index + 1); });

          this.track.addEventListener('scroll', function () {
            if (self._ticking) return;
            self._ticking = true;
            requestAnimationFrame(function () {
              self.sync();
              self._ticking = false;
            });
          }, { passive: true });

          this.maybeNudge();
        }

        step() {
          /* largeur d'un slide + gap = écart entre 2 slides */
          if (this.slides.length < 2) return this.slides[0] ? this.slides[0].offsetWidth : 0;
          return this.slides[1].offsetLeft - this.slides[0].offsetLeft;
        }

        go(n) {
          n = Math.max(0, Math.min(this.slides.length - 1, n));
          this.track.scrollTo({
            left: this.slides[n].offsetLeft,
            behavior: REDUCE ? 'auto' : 'smooth'
          });
        }

        /* Saut sur la photo d'une variante. Appelé quand la cliente change de coloris :
           la galerie se cale sur l'image liée à la variante dans l'admin. Sans image
           associée, on ne fait rien plutot que de sauter sur une photo au hasard. */
        goToMedia(mediaId) {
          if (!mediaId || !this.slides || this.slides.length < 2) return;
          for (var i = 0; i < this.slides.length; i++) {
            if (this.slides[i].getAttribute('data-media-id') === String(mediaId)) {
              this.go(i);
              this.index = i;
              if (this.current) this.current.textContent = i + 1;
              if (this.dots) this.dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
              return;
            }
          }
        }

        sync() {
          var st = this.step();
          if (!st) return;
          var idx = Math.round(this.track.scrollLeft / st);
          idx = Math.max(0, Math.min(this.slides.length - 1, idx));
          if (idx === this.index) return;
          this.index = idx;
          if (this.current) this.current.textContent = idx + 1;
          this.dots.forEach(function (d, k) { d.classList.toggle('is-active', k === idx); });
        }

        maybeNudge() {
          if (REDUCE || this.getAttribute('data-nudge') !== 'true') return;
          var self = this;
          var done = false;
          if (!('IntersectionObserver' in window)) return;
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (!e.isIntersecting || done) return;
              done = true;
              io.disconnect();
              self.track.scrollTo({ left: 46, behavior: 'smooth' });
              setTimeout(function () { self.track.scrollTo({ left: 0, behavior: 'smooth' }); }, 480);
            });
          }, { threshold: 0.4 });
          io.observe(this);
        }
      }
    );
  }

  /* ---------------------------------------------------------------------
     <facil-savoir-plus> — déclencheur externe d'accordéon (pattern REFY)
     --------------------------------------------------------------------- */
  if (!customElements.get('facil-savoir-plus')) {
    customElements.define(
      'facil-savoir-plus',
      class FacilSavoirPlus extends HTMLElement {
        connectedCallback() {
          var sel = this.getAttribute('data-target');
          var self = this;
          this.addEventListener('click', function (e) {
            if (e.target.closest('a, button')) e.preventDefault();
            var target = sel && document.querySelector(sel);
            if (!target) return;
            if (!target.open) {
              var opener = target.querySelector('summary');
              if (opener) opener.click(); /* passe par le handler accordéon → déroulement animé */
            }
            target.scrollIntoView({ behavior: REDUCE ? 'auto' : 'smooth', block: 'start' });
            var summary = target.querySelector('summary');
            if (summary) summary.focus({ preventScroll: true });
          });
        }
      }
    );
  }

  /* ---------------------------------------------------------------------
     <facil-add> — ajout AJAX 1 clic (cartes cross-sell + bundle)
     Miroir de product-form.js : POST /cart/add.js avec sections= → re-render tiroir.
     --------------------------------------------------------------------- */
  if (!customElements.get('facil-add')) {
    customElements.define(
      'facil-add',
      class FacilAdd extends HTMLElement {
        connectedCallback() {
          this.btn = this.querySelector('button');
          if (!this.btn) return;
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          this.btn.addEventListener('click', this.onClick.bind(this));
        }

        onClick(e) {
          e.preventDefault();
          var id = this.getAttribute('data-variant-id');
          if (!id || this.btn.getAttribute('aria-disabled') === 'true') return;

          this.btn.setAttribute('aria-disabled', 'true');
          this.btn.classList.add('loading');
          var spinner = this.btn.querySelector('.loading__spinner');
          if (spinner) spinner.classList.remove('hidden');

          var config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: {} };
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          var fd = new FormData();
          fd.append('id', id);
          fd.append('quantity', '1');
          if (this.cart && this.cart.getSectionsToRender) {
            fd.append('sections', this.cart.getSectionsToRender().map(function (s) { return s.id; }));
            fd.append('sections_url', window.location.pathname);
            if (this.cart.setActiveElement) this.cart.setActiveElement(document.activeElement);
          }
          config.body = fd;

          var self = this;
          fetch(window.routes.cart_add_url, config)
            .then(function (r) { return r.json(); })
            .then(function (res) {
              if (res.status) return; /* rupture/erreur : on ne casse rien */
              if (self.cart && self.cart.renderContents) {
                if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                  publish(PUB_SUB_EVENTS.cartUpdate, { source: 'facil-add', productVariantId: id, cartData: res });
                }
                self.cart.renderContents(res);
              } else {
                window.location = window.routes.cart_url;
              }
            })
            .catch(function (err) { console.error(err); })
            .finally(function () {
              self.btn.classList.remove('loading');
              self.btn.removeAttribute('aria-disabled');
              if (spinner) spinner.classList.add('hidden');
              if (self.cart && self.cart.classList.contains('is-empty')) self.cart.classList.remove('is-empty');
            });
        }
      }
    );
  }

  /* ---------------------------------------------------------------------
     <facil-pair> — onglets compacts « Pair It With » (routine / offre)
     --------------------------------------------------------------------- */
  if (!customElements.get('facil-pair')) {
    customElements.define(
      'facil-pair',
      class FacilPair extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.prototype.slice.call(this.querySelectorAll('[data-pair-tab]'));
          this.panels = Array.prototype.slice.call(this.querySelectorAll('[data-pair-panel]'));
          this.panelsWrap = this.querySelector('.facil-pair__panels');
          if (this.tabs.length < 2) return;
          var self = this;
          this.tabs.forEach(function (tab) {
            tab.addEventListener('click', function () { self.show(tab.getAttribute('data-pair-tab')); });
          });
        }

        show(key) {
          this.tabs.forEach(function (t) {
            var on = t.getAttribute('data-pair-tab') === key;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });

          var wrap = this.panelsWrap;
          var startH = wrap ? wrap.offsetHeight : 0;
          var newPanel = null;
          this.panels.forEach(function (p) {
            var on = p.getAttribute('data-pair-panel') === key;
            p.classList.toggle('is-hidden', !on);
            if (on) newPanel = p;
          });

          /* nouveau panneau : fondu + léger glissé */
          if (newPanel && !REDUCE) {
            newPanel.classList.remove('facil-pair__panel--in');
            void newPanel.offsetWidth;
            newPanel.classList.add('facil-pair__panel--in');
          }
          /* conteneur : on anime la hauteur (évite le saut entre les 2 hauteurs) */
          if (!wrap || REDUCE) return;
          var endH = wrap.scrollHeight;
          if (startH === endH) return;
          wrap.style.overflow = 'hidden';
          wrap.style.height = startH + 'px';
          void wrap.offsetWidth;
          wrap.style.transition = 'height 0.32s ease';
          wrap.style.height = endH + 'px';
          var t;
          function end() {
            clearTimeout(t);
            wrap.removeEventListener('transitionend', te);
            wrap.style.transition = '';
            wrap.style.height = '';
            wrap.style.overflow = '';
          }
          function te(e) { if (e.target === wrap && e.propertyName === 'height') end(); }
          wrap.addEventListener('transitionend', te);
          t = setTimeout(end, 440);
        }
      }
    );
  }

  /* ---------------------------------------------------------------------
     Accordéons <details class="facil-acc"> — déroulement animé (ouverture + fermeture).
     Le natif « snape » (le contenu est masqué hors [open] → la transition CSS ne joue pas) :
     on pilote donc la hauteur en JS. Sans JS / reduced-motion → <details> natif (dégradation propre).
     --------------------------------------------------------------------- */
  var ACC_OPEN = 380, ACC_CLOSE = 320;

  function facilAccAnimate(details, content, opening) {
    var dur = opening ? ACC_OPEN : ACC_CLOSE;
    if (opening) details.open = true;
    content.style.overflow = 'hidden';
    var full = content.scrollHeight;
    content.style.height = (opening ? 0 : full) + 'px';
    content.style.opacity = opening ? '0' : '1';
    content.offsetHeight; /* reflow pour figer l'état de départ */
    content.style.transition = 'height ' + dur + 'ms ease, opacity ' + Math.round(dur * 0.7) + 'ms ease';
    content.style.height = (opening ? full : 0) + 'px';
    content.style.opacity = opening ? '1' : '0';

    var fallback;
    function done() {
      content.removeEventListener('transitionend', onEnd);
      clearTimeout(fallback);
      content.style.transition = '';
      content.style.height = '';
      content.style.opacity = '';
      content.style.overflow = '';
      if (!opening) details.open = false; /* on masque APRÈS l'anim de fermeture */
    }
    function onEnd(e) { if (e.target === content && e.propertyName === 'height') done(); }
    content.addEventListener('transitionend', onEnd);
    fallback = setTimeout(done, dur + 90); /* filet de sécurité si transitionend manque */
  }

  /* Accordéon exclusif : ferme tout autre accordéon ouvert du même groupe. */
  function facilAccCloseSiblings(current) {
    var group = current.closest('.facil-pdp__accordions') || current.parentNode;
    if (!group) return;
    Array.prototype.slice.call(group.querySelectorAll('.facil-acc')).forEach(function (d) {
      if (d === current || !d.open) return;
      var c = d.querySelector('.facil-acc__content');
      if (!c) return;
      if (REDUCE) { d.open = false; return; }
      if (!c.style.transition) facilAccAnimate(d, c, false); /* enroule l'ouvert (animé) */
    });
  }

  function facilAccSetup(details) {
    if (details.dataset.accReady) return;
    var summary = details.querySelector('summary');
    var content = details.querySelector('.facil-acc__content');
    if (!summary || !content) return;
    details.dataset.accReady = '1';
    summary.addEventListener('click', function (e) {
      var opening = !details.open;
      if (REDUCE) {
        if (opening) facilAccCloseSiblings(details); /* exclusif même sans animation */
        return; /* <details> natif gère l'ouverture du cliqué */
      }
      e.preventDefault();
      if (content.style.transition) return; /* animation déjà en cours → on ignore */
      if (opening) facilAccCloseSiblings(details); /* un seul ouvert : ferme l'autre */
      facilAccAnimate(details, content, opening);
    });
  }

  Array.prototype.slice.call(document.querySelectorAll('.facil-acc')).forEach(facilAccSetup);
  window.facilAccordions = function (root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.slice.call(scope.querySelectorAll('.facil-acc')).forEach(facilAccSetup);
  };
})();

/* ============================================================================
   Barre ATC collante (mobile) — visible quand le bouton ATC principal sort du
   viewport (IntersectionObserver). Le bouton de la barre clique le bouton
   principal (ajout AJAX natif). Prix + état rupture synchronisés depuis le
   bouton principal (MutationObserver). Le CSS limite l'affichage au mobile.
   ============================================================================ */
(function () {
  var bar = document.querySelector('.facil-atcbar');
  if (!bar) return;
  var mainBtn = document.querySelector('[data-pdp-submit]');
  if (!mainBtn) return;
  var mainPrice = document.querySelector('[data-pdp-btn-price]');
  var barPrice = bar.querySelector('[data-atcbar-price]');
  var barBtn = bar.querySelector('[data-atcbar-add]');

  function sync() {
    if (mainPrice && barPrice) barPrice.textContent = mainPrice.textContent;
    if (barBtn) barBtn.disabled = mainBtn.disabled || mainBtn.hasAttribute('disabled');
  }
  sync();
  if ('MutationObserver' in window) {
    new MutationObserver(sync).observe(mainBtn, { attributes: true, childList: true, subtree: true });
  }
  if (barBtn) barBtn.addEventListener('click', function () { mainBtn.click(); });

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var show = !entries[0].isIntersecting;
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('has-atcbar', show);
    }, { rootMargin: '0px 0px -8px 0px' }).observe(mainBtn);
  }
})();
